import { useEffect, useState } from 'react'
import { AssetColumn, AssetInventoryType } from 'models'
import { AssetInventoryServiceV4 } from 'services'

export type AssetColumnsStatus = 'loading' | 'ready' | 'failed'

/* The tab's columns from the model manifest; the grid waits on them before it asks for rows. */
export const useAssetColumns = (assetType: AssetInventoryType) => {
  const [columns, setColumns] = useState<AssetColumn[]>([])
  const [status, setStatus] = useState<AssetColumnsStatus>('loading')

  useEffect(() => {
    let cancelled = false

    setStatus('loading')

    AssetInventoryServiceV4.getColumns(assetType)
      .then((next) => {
        if (cancelled) return

        setColumns(next)
        setStatus('ready')
      })
      .catch((error) => {
        console.error(error)

        if (!cancelled) setStatus('failed')
      })

    return () => {
      cancelled = true
    }
  }, [assetType])

  return { columns, status }
}
